// extracted by mini-css-extract-plugin
export default {"avatar":"Article_avatar__cjK09","cell":"Article_cell__iJDDf","flex":"Article_flex__EB7DQ","block":"Article_block__7oNFF"};